import useUIStore from "@/shared/stores/ui/store"

export const toast = {
  success: (message: string) => {
    useUIStore.getState().showToast("success", message)
  },
  error: (message: string) => {
    useUIStore.getState().showToast("error", message)
  },
  info: (message: string) => {
    useUIStore.getState().showToast("info", message)
  },
  warning: (message: string) => {
    useUIStore.getState().showToast("warning", message)
  },
}
